import { DialogsService } from './dialogs.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';

import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import {TransferCaseDialogComponent} from './transfer-case-dialog/transfer-case-dialog.component';
import {ControlsModule} from '../controls/controls.module';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule,
        ControlsModule
    ],
    exports: [
        AlertDialogComponent,
        ConfirmDialogComponent,
        MatDialogModule,
        TransferCaseDialogComponent
    ],
    declarations: [
        AlertDialogComponent,
        ConfirmDialogComponent,
        TransferCaseDialogComponent
    ],
    providers: [
        DialogsService,
    ],
    entryComponents: [
        AlertDialogComponent,
        TransferCaseDialogComponent,
        ConfirmDialogComponent
    ],
})
export class DialogsModule { }
